import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
} from '@material-ui/core';
import useStyles from './style';
import { InternalInfo, ExternalInfo } from './components';

const OrderInfo = props => {
  const { order, isInternalCall, className, ...rest } = props;
  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Order info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            {isInternalCall && <InternalInfo order={order} />}
            {!isInternalCall && <ExternalInfo order={order} />}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

OrderInfo.propTypes = {
  className: PropTypes.string,
  order: PropTypes.object.isRequired,
  isInternalCall: PropTypes.bool,
};

OrderInfo.defaultProps = {
  isInternalCall: false,
}

export default OrderInfo;
